import type { RematchDispatch, RematchRootState } from '@rematch/core';
import { init } from '@rematch/core';
import type { ExtraModelsFromLoading } from '@rematch/loading';
import loadingPlugin from '@rematch/loading';
import vision from 'components/App/models';
import loginPage from 'routes/LoginPage/models';
// models
import support from 'routes/Support/models';

// API middleware
import API from './rematchAPICall';

const models = {
    vision,
    loginPage,
    API,
    support,
};

type RootModel = typeof models;
type FullModel = ExtraModelsFromLoading<RootModel>;

export type Dispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<RootModel, FullModel>;

// ======================================================
// Store Instantiation
// ======================================================
const store = init<RootModel, FullModel>({
    models,
    plugins: [loadingPlugin()],
    redux: {
        rootReducers: {
            RESET_STATE: (rootState) => ({ vision: rootState.vision }),
        },
    },
});

// ========================================================
// History and Store Instantiation
// ========================================================
// We need store access to dispatch actions
export const { dispatch } = store;

export default store;
